module.exports = __webpack_public_path__ + "assets/arrow.316db063.svg";